import { render } from "./LicenseItemView.vue?vue&type=template&id=63292c8c"
import script from "./LicenseItemView.vue?vue&type=script&lang=js"
export * from "./LicenseItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__